/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import {
  Department,
  Organization,
  AccessControlRole
} from '@/generated/graphql';
import { ReactiveVar, makeVar } from '@apollo/client';

interface CurrentUserDetails {
  department: Department | null;
  permissions: string[];
  email: string | null;
  name: string | undefined | null;
  lastName?: string | undefined | null;
  id: string | null;
  role: AccessControlRole;
  organization: Organization | null;
  isDemoUser: boolean;
  dataLoading: boolean;
}

export const currentUserDetailsVar: ReactiveVar<CurrentUserDetails> =
  makeVar<CurrentUserDetails>({
    department: null,
    permissions: [],
    email: '',
    name: '',
    lastName: '',
    id: '',
    role: AccessControlRole.Admin,
    organization: null,
    isDemoUser: false,
    dataLoading: true
  });
